export default __webpack_public_path__ + "static/media/lockScreen-bg.ea7a48f2.png";